import React from 'react';
import Contact from 'src/interfaces/api/Contact';
import useContacts from './useContacts';

interface ReturnType {
  contact?: Contact;
}

export default function useContact(id: Contact['id']): ReturnType {
  const { contacts, siteContacts, get } = useContacts();

  let contact = siteContacts.find((contact) => contact.id === id);

  if (!contact) {
    contact = contacts.find((contact) => contact.id === id);

    if (!contact) {
      get(id);
    }
  }

  return { contact };
}
